"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const AppButton_vue_1 = require("@/client/components/common/AppButton.vue");
const UndergroundToken_vue_1 = require("@/client/components/underworld/UndergroundToken.vue");
exports.default = vue_1.default.extend({
    name: 'SelectClaimedUndergroundToken',
    props: {
        playerView: {
            type: Object,
        },
        playerinput: {
            type: Object,
        },
        onsave: {
            type: Function,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data() {
        return {
            selected: [],
        };
    },
    components: {
        AppButton: AppButton_vue_1.default,
        UndergroundToken: UndergroundToken_vue_1.default,
    },
    methods: {
        canSave() {
            if (this.selected.length > this.playerinput.max) {
                return false;
            }
            if (this.selected.length < this.playerinput.min) {
                return false;
            }
            return true;
        },
        saveData() {
            this.onsave({ type: 'claimedUndergroundToken', selected: this.selected.sort() });
        },
    },
});
